/**
 * Optional `window.LP_BASENAME` — only when the app is mounted under a URL prefix
 * (e.g. `https://site.com/player/` → `"/player"`).
 *
 * If `LP_BASENAME` is set but `location.pathname` does **not** start with it, React Router v6
 * renders **nothing** (blank white page) and no API calls run. This usually happens when a
 * template sets `LP_BASENAME` incorrectly.
 *
 * For URLs like `https://course…/course/30` with routes `/course/:courseId`, leave
 * **`LP_BASENAME` unset** (or remove it from the template).
 */
export function getSafeRouterBasename(): string | undefined {
  if (typeof window === "undefined") return undefined;
  const raw = (window as unknown as { LP_BASENAME?: string }).LP_BASENAME?.trim();
  if (!raw) return undefined;

  let b = raw.startsWith("/") ? raw : `/${raw}`;
  b = b.replace(/\/+$/, "") || "/";
  if (b === "/") return undefined;

  const path = window.location.pathname;
  if (!path.startsWith(b)) {
    console.warn(
      `[Lesson Player] Ignoring LP_BASENAME=${JSON.stringify(raw)} — pathname ${JSON.stringify(
        path
      )} does not start with it. Wrong basename causes a blank page. Remove LP_BASENAME unless the app lives under that path.`
    );
    return undefined;
  }

  return b;
}
